import { GlLink } from '@gitlab/ui';
import { __ } from '~/locale';
import HelpPopover from '~/vue_shared/components/help_popover.vue';
import SafeHtml from '~/vue_shared/directives/safe_html';
import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
import { EXTENSION_ICONS } from '../../constants';
import { generateText } from './utils';
import ActionButtons from './action_buttons.vue';
import StatusIcon from './status_icon.vue';
export default {
    name: 'WidgetContentRow',
    components: {
        StatusIcon,
        HelpPopover,
        GlLink,
        ActionButtons
    },
    directives: {
        SafeHtml
    },
    mixins: [
        glSlotsMixin
    ],
    props: {
        level: {
            type: Number,
            required: true,
            validator: (value)=>value === 2 || value === 3
        },
        statusIconName: {
            type: String,
            required: false,
            default: '',
            validator: (value)=>value === '' || Object.keys(EXTENSION_ICONS).includes(value)
        },
        isLoading: {
            type: Boolean,
            required: false,
            default: false
        },
        widgetName: {
            type: String,
            required: true
        },
        header: {
            type: [
                String,
                Array
            ],
            required: false,
            default: ''
        },
        /**
     * @typedef {Object} helpPopover
     * @property {Object} options
     * @property {String} options.title
     * @property {Object} content
     * @property {String} content.text
     * @property {String} content.learnMorePath
     */ helpPopover: {
            type: Object,
            required: false,
            default: null
        },
        actionButtons: {
            type: Array,
            required: false,
            default: ()=>[]
        }
    },
    computed: {
        generatedHeader () {
            return generateText(Array.isArray(this.header) ? this.header[0] : this.header);
        },
        generatedSubheader () {
            return Array.isArray(this.header) && this.header[1] ? generateText(this.header[1]) : '';
        },
        shouldShowHeaderActions () {
            return Boolean(this.helpPopover) || this.actionButtons?.length > 0;
        },
        hasActionButtons () {
            return this.actionButtons.length > 0;
        }
    },
    methods: {
        hasHeader () {
            return Boolean(this.glSlots().header || this.header || this.shouldShowHeaderActions);
        }
    },
    i18n: {
        learnMore: __('Learn more')
    }
};
